import { InfoOutlined } from '@ant-design/icons';
import { Flex, Modal, Typography } from 'antd';
import React from 'react';
import { COLORS } from 'shared/const/theme';
import { RoundContainer } from 'shared/ui';

import { useIntl } from 'react-intl';

type GetPlasticProps = {
  open: boolean;
  onClose: () => unknown;
};

const GetPlastic: React.FC<GetPlasticProps> = ({ open, onClose }) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered>
      <Flex vertical align='center' gap={16}>
        <RoundContainer size={48} color={COLORS.PRIMARY} >
          <InfoOutlined style={{ color: '#fff', fontSize: 24 }} />
        </RoundContainer>
        <Typography.Text>
          {t({ id: "card.get.plastic.availableSoon" })}
        </Typography.Text>
      </Flex>
    </Modal>
  );
};

export default GetPlastic;
